import { Drawer, useGlobalCopyStore } from '../../../../common'
import TrendsChart from '../../../../trends/components/TrendsChart'

import AccountDetailsContent from './AccountDetailsContent'
import AccountDetailsHeader from './AccountDetailsHeader'

interface AccountDetailsDrawerProps {
  isOpen: boolean
  onClose: () => void
}

const AccountDetailsDrawer = ({ isOpen, onClose }: AccountDetailsDrawerProps) => {
  const { accounts: accountsCopy } = useGlobalCopyStore()

  return (
    <Drawer
      ariaLabelClose={accountsCopy.close_account_details_aria}
      isOpen={isOpen}
      onClose={onClose}
      title={accountsCopy.account_details}
    >
      <AccountDetailsHeader ChartComponent={TrendsChart} />

      <AccountDetailsContent />
    </Drawer>
  )
}

export default AccountDetailsDrawer
